import {defineMessages } from "react-intl"

export const generateOptions = (intlService) => {
    const messages = defineMessages({
        "status_new": {
            id: "quote.status_selection.status_new",
            defaultMessage: "New",
        },
        "status_draft": {
            id: "quote.status_selection.status_draft",
            defaultMessage: "Draft",
        },
        "status_proposed": {
            id: "quote.status_selection.status_proposed",
            defaultMessage: "Proposed",
        },
        "status_pre_approved": {
            id: "quote.status_selection.status_pre_approved",
            defaultMessage: "Pre approved",
        },
        "status_approved": {
            id: "quote.status_selection.status_approved",
            defaultMessage: "Approved",
        },
        "status_declined": {
            id: "quote.status_selection.status_declined",
            defaultMessage: "Declined",
        },
        "status_cancelled": {
            id: "quote.status_selection.status_cancelled",
            defaultMessage: "Cancelled",
        },
        "status_invoiced": {
            id: "quote.status_selection.status_invoiced",
            defaultMessage: "Invoiced",
        },
        "status_ordered": {
            id: "quote.status_selection.status_ordered",
            defaultMessage: "Ordered",
        },
    })
    
    return [
        {
            value: "new",
            label: intlService.formatMessage(messages["status_new"])
        },
        {
            value: "draft",
            label: intlService.formatMessage(messages["status_draft"])
        },
        {
            value: "proposed",
            label: intlService.formatMessage(messages["status_proposed"])
        },
        {
            value: "pre-approved",
            label: intlService.formatMessage(messages["status_pre_approved"])
        },
        {
            value: "approved",
            label: intlService.formatMessage(messages["status_approved"])
        },
        {
            value: "invoiced",
            label: intlService.formatMessage(messages["status_invoiced"])
        },
        {
            value: "ordered",
            label: intlService.formatMessage(messages["status_ordered"])
        },
        {
            value: "declined",
            label: intlService.formatMessage(messages["status_declined"])
        },
        {
            value: "cancelled",
            label: intlService.formatMessage(messages["status_cancelled"])
        },
    ]
}


// WEBPACK FOOTER //
// ./src/quote/utils/QuoteStatus.ts